import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/automab-antibody-at.svg'
import _imports_1 from './assets/settings.svg'
import _imports_2 from './assets/file.svg'
import _imports_3 from './assets/reset.svg'
import _imports_4 from './assets/bpmn.svg'
import _imports_5 from './assets/3D-cube.svg'
import _imports_6 from './assets/tag.svg'
import _imports_7 from './assets/meeting.svg'


const _withScopeId = n => (_pushScopeId("data-v-0cd30918"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "AutoMAb Logo",
    class: "sidebar-logo"
  })
], -1))
const _hoisted_2 = { class: "sidebar-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "settings",
  class: "icon"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "folder",
  class: "icon"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "reset",
  class: "icon"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "bpmn",
  class: "icon"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "viewer",
  class: "icon"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: "game",
  class: "icon"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "meeting",
  class: "icon"
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "autodesk oauth",
  class: "icon"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["title"]
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = ["title"]
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "sidebar-bottom" }
const _hoisted_26 = ["title"]
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = {
  class: "filter-container",
  ref: "filterContainer"
}
const _hoisted_29 = {
  key: 0,
  class: "automab-tabs-container"
}
const _hoisted_30 = { class: "tabs-header" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = ["onDblclick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "tabs-content" }
const _hoisted_36 = {
  key: 0,
  class: "side-panel"
}
const _hoisted_37 = {
  key: 1,
  class: "side-panel"
}
const _hoisted_38 = { class: "dev-chat-status-bar" }
const _hoisted_39 = { class: "status-section" }
const _hoisted_40 = { class: "status-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "User:", -1))
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "status-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Email:", -1))
const _hoisted_45 = { class: "value" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-icon" }, "⇪", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-text" }, "Share", -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-icon" }, "↺", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-text" }, "Reset", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-icon" }, "⏻", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "status-text" }, "Logout", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = {
  key: 0,
  class: "status-item task-context"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Task:", -1))
const _hoisted_57 = { class: "value" }
const _hoisted_58 = {
  key: 0,
  class: "status-item"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "ChatModel:", -1))
const _hoisted_60 = { class: "value" }
const _hoisted_61 = { class: "status-item server-status" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "API:", -1))
const _hoisted_63 = { class: "value" }
const _hoisted_64 = ["value"]
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Switch API Server", -1))
const _hoisted_66 = ["value", "selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageFilter = _resolveComponent("MessageFilter")!
  const _component_ChatContent = _resolveComponent("ChatContent")!
  const _component_TagEditorModal = _resolveComponent("TagEditorModal")!
  const _component_CorporateAIEditorModal = _resolveComponent("CorporateAIEditorModal")!
  const _component_SettingsModal = _resolveComponent("SettingsModal")!
  const _component_ViewerModal = _resolveComponent("ViewerModal")!
  const _component_FilesModal = _resolveComponent("FilesModal")!
  const _component_MeetingMenu = _resolveComponent("MeetingMenu")!
  const _component_BpmnModelerModal = _resolveComponent("BpmnModelerModal")!
  const _component_ConfigEditorModal = _resolveComponent("ConfigEditorModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "dev-chat",
      class: _normalizeClass({ 'sidebar-open': _ctx.isMenuOpen })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["sidebar", { 'open': _ctx.isMenuOpen }]),
        onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.featureFlags.hasJiraCloudIntegration)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSettings && _ctx.openSettings(...args))),
                title: "Settings"
              }, _hoisted_4))
            : _createCommentVNode("", true),
          (!_ctx.featureFlags.hasJiraCloudIntegration)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFilesModal && _ctx.openFilesModal(...args))),
                title: "Manage Files"
              }, _hoisted_6))
            : _createCommentVNode("", true),
          (!_ctx.featureFlags.hasTextDevChat)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
                title: "Reset Chat"
              }, _hoisted_8))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args))),
            title: _ctx.showFilter ? 'Hide Filter' : 'Show Filter'
          }, [
            _createElementVNode("img", {
              src: _ctx.showFilter ? _ctx.noFilterIcon : _ctx.filterIcon,
              alt: _ctx.showFilter ? 'filter' : 'no filter',
              class: "icon"
            }, null, 8, _hoisted_10)
          ], 8, _hoisted_9),
          (!_ctx.featureFlags.hasJiraCloudIntegration || _ctx.auth.isWebAdminMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openBpmnModeler && _ctx.openBpmnModeler(...args))),
                title: "Open BPMN Modeler"
              }, _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.auth.isAutomabApp)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openViewer && _ctx.openViewer(...args))),
                title: "3D Viewer"
              }, _hoisted_14))
            : _createCommentVNode("", true),
          (!_ctx.auth.isAutomabApp && !_ctx.featureFlags.hasJiraCloudIntegration)
            ? (_openBlock(), _createElementBlock("button", {
                key: 5,
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openGame && _ctx.openGame(...args))),
                title: "Open Game"
              }, _hoisted_16))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openMeetingMenu && _ctx.openMeetingMenu(...args))),
            title: "Open Meeting Menu"
          }, _hoisted_18),
          (_ctx.featureFlags.hasAutodeskThreeLeggedOauth && _ctx.auth.isWebAdminMode)
            ? (_openBlock(), _createElementBlock("button", {
                key: 6,
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.requestAutodeskOAuth && _ctx.requestAutodeskOAuth(...args))),
                title: "Generate Autodesk OAuth code"
              }, _hoisted_20))
            : _createCommentVNode("", true),
          (_ctx.featureFlags.hasAudioInteraction)
            ? (_openBlock(), _createElementBlock("button", {
                key: 7,
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cycleIconState && _ctx.cycleIconState(...args))),
                title: _ctx.getIconTitle
              }, [
                _createElementVNode("img", {
                  src: _ctx.getCurrentIcon,
                  alt: _ctx.getIconTitle,
                  class: "icon"
                }, null, 8, _hoisted_22)
              ], 8, _hoisted_21))
            : _createCommentVNode("", true),
          (_ctx.featureFlags.hasAudioInteraction)
            ? (_openBlock(), _createElementBlock("button", {
                key: 8,
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.cycleObserverIconState && _ctx.cycleObserverIconState(...args))),
                title: _ctx.getObserverIconTitle,
                class: "observer-button"
              }, [
                _createElementVNode("img", {
                  src: _ctx.getObserverIcon,
                  alt: _ctx.getObserverIconTitle,
                  class: "icon"
                }, null, 8, _hoisted_24)
              ], 8, _hoisted_23))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.featureFlags.hasAudioInteraction)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.toggleAudioMuting && _ctx.toggleAudioMuting(...args))),
                class: "audio-control",
                title: _ctx.isMicMuted ? 'Unmute mic' : 'Mute mic'
              }, [
                _createElementVNode("img", {
                  src: _ctx.isMicMuted ? _ctx.micOffIcon : _ctx.micOnIcon,
                  alt: _ctx.isMicMuted ? 'mic muted' : 'mic',
                  class: "icon"
                }, null, 8, _hoisted_27)
              ], 8, _hoisted_26))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_28, [
        (_ctx.showFilter)
          ? (_openBlock(), _createBlock(_component_MessageFilter, {
              key: 0,
              onApplySimpleFilter: _ctx.applySimpleFilter,
              onApplyMongoFilter: _ctx.applyMongoFilter,
              onGenerateFilter: _ctx.handleGenerateFilter
            }, null, 8, ["onApplySimpleFilter", "onApplyMongoFilter", "onGenerateFilter"]))
          : _createCommentVNode("", true)
      ], 512),
      (_ctx.auth.isAutomabApp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.automabTabs, (tab, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["tab-button", { active: _ctx.activeTabIndex === index }]),
                  onClick: ($event: any) => (_ctx.switchTab(index))
                }, [
                  (_ctx.editingTabIndex === index)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        "onUpdate:modelValue": ($event: any) => ((tab.name) = $event),
                        onBlur: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.finishEditing && _ctx.finishEditing(...args))),
                        onKeyup: _cache[14] || (_cache[14] = _withKeys(
//@ts-ignore
(...args) => (_ctx.finishEditing && _ctx.finishEditing(...args)), ["enter"])),
                        ref_for: true,
                        ref: el => _ctx.setTabInputRef(el, index),
                        class: "tab-name-input",
                        onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                      }, null, 40, _hoisted_32)), [
                        [_vModelText, tab.name]
                      ])
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        onDblclick: _withModifiers(($event: any) => (_ctx.startEditing(index)), ["stop"])
                      }, _toDisplayString(tab.name), 41, _hoisted_33)),
                  _createElementVNode("button", {
                    class: "close-tab",
                    onClick: _withModifiers(($event: any) => (_ctx.closeTab(index)), ["stop"])
                  }, "×", 8, _hoisted_34)
                ], 10, _hoisted_31))
              }), 128)),
              _createElementVNode("button", {
                class: "add-tab",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.addNewTab && _ctx.addNewTab(...args)))
              }, "+")
            ]),
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.automabTabs, (tab, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["automab-html", { active: _ctx.activeTabIndex === index }]),
                  ref_for: true,
                  ref: el => _ctx.setTabRef(el, index)
                }, null, 2))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredChatStack, (chatMessages, index) => {
        return (_openBlock(), _createBlock(_component_ChatContent, {
          key: index,
          messages: chatMessages,
          isLoading: _ctx.isLoading && index === _ctx.filteredChatStack.length - 1,
          showTriggerSystem2Button: _ctx.showTriggerSystem2Button && index === 0,
          depth: index,
          auth: _ctx.auth,
          chatService: _ctx.chatService,
          ref_for: true,
          ref: "chatContentComponents",
          onTriggerSystem2: _ctx.triggerSystem2,
          onOpenTraceInfo: _ctx.openTraceInfo,
          onClose: ($event: any) => (_ctx.closeTraceInfo(index)),
          onSendMessage: _ctx.sendMessage,
          onAttachFile: _ctx.handleAttachment,
          onButtonClick: _ctx.handleButtonAction,
          class: "chat-content"
        }, null, 8, ["messages", "isLoading", "showTriggerSystem2Button", "depth", "auth", "chatService", "onTriggerSystem2", "onOpenTraceInfo", "onClose", "onSendMessage", "onAttachFile", "onButtonClick"]))
      }), 128)),
      (_ctx.isTagEditorOpen)
        ? (_openBlock(), _createBlock(_component_TagEditorModal, {
            key: 1,
            processorService: _ctx.chatService,
            onClose: _ctx.closeTagEditor
          }, null, 8, ["processorService", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.isCorporateAIEditorOpen)
        ? (_openBlock(), _createBlock(_component_CorporateAIEditorModal, {
            key: 2,
            processorService: _ctx.chatService,
            onClose: _ctx.closeCorporateAIEditor
          }, null, 8, ["processorService", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.isSettingsOpen)
        ? (_openBlock(), _createBlock(_component_SettingsModal, {
            key: 3,
            onClose: _ctx.closeSettings,
            onSave: _ctx.saveSettings,
            onPair: _ctx.handlePair
          }, null, 8, ["onClose", "onSave", "onPair"]))
        : _createCommentVNode("", true),
      (_ctx.isViewerOpen && _ctx.auth.isAutomabApp)
        ? (_openBlock(), _createBlock(_component_ViewerModal, {
            key: 4,
            searchString: _ctx.viewerSearchString,
            onClose: _ctx.closeViewer
          }, null, 8, ["searchString", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.isFilesModalOpen)
        ? (_openBlock(), _createBlock(_component_FilesModal, {
            key: 5,
            processorService: _ctx.chatService,
            onClose: _ctx.closeFilesModal
          }, null, 8, ["processorService", "onClose"]))
        : _createCommentVNode("", true),
      (_ctx.isMeetingMenuOpen)
        ? (_openBlock(), _createBlock(_component_MeetingMenu, {
            key: 6,
            onClose: _ctx.closeMeetingMenu
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true),
      (_ctx.isBpmnModelerOpen || _ctx.isConfigEditorOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 7,
            class: _normalizeClass(["side-by-side-container", { 'sidebar-open': _ctx.isMenuOpen }])
          }, [
            (_ctx.isBpmnModelerOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createVNode(_component_BpmnModelerModal, {
                    processorService: _ctx.chatService,
                    onClose: _ctx.closeBpmnModeler,
                    onNodeSelected: _ctx.handleBpmnNodeSelected,
                    onNodeDeleted: _ctx.handleBpmnNodeDeleted,
                    inlineMode: true,
                    onSave: _ctx.handleBpmnSave,
                    hasUnsavedChanges: _ctx.hasUnsavedChanges,
                    onModelChanged: _ctx.onModelChanged,
                    onFactoryReset: _ctx.handleFactoryReset
                  }, null, 8, ["processorService", "onClose", "onNodeSelected", "onNodeDeleted", "onSave", "hasUnsavedChanges", "onModelChanged", "onFactoryReset"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isConfigEditorOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_ConfigEditorModal, {
                    ref: "configEditorModal",
                    processorService: _ctx.chatService,
                    show: _ctx.isConfigEditorOpen,
                    "selected-node": _ctx.selectedBpmnNode,
                    onClose: _ctx.closeConfigEditor,
                    inlineMode: true,
                    onConfigChanged: _ctx.onConfigChanged
                  }, null, 8, ["processorService", "show", "selected-node", "onClose", "onConfigChanged"])
                ]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_38, [
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.auth.userName), 1)
        ]),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.auth.userEmail), 1)
        ]),
        _createElementVNode("button", {
          class: "status-button",
          onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.handleShare && _ctx.handleShare(...args))),
          title: "Share"
        }, _hoisted_48),
        _createElementVNode("button", {
          class: "status-button",
          onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args))),
          title: "Reset"
        }, _hoisted_51),
        _createElementVNode("button", {
          class: "status-button",
          onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
          title: "Logout"
        }, _hoisted_54),
        (_ctx.taskContext)
          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.taskContext), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.chatModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.chatModel), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_61, [
        _hoisted_62,
        _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.ProcessorService.getServerHostPort()), 1),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("select", {
              key: 0,
              class: "server-select",
              value: _ctx.auth.server,
              onChange: _cache[20] || (_cache[20] = (e) => _ctx.switchServer((e.target as HTMLSelectElement).value))
            }, [
              _hoisted_65,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableServers, (s) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: s,
                  value: s,
                  selected: s === _ctx.auth.server
                }, _toDisplayString(s), 9, _hoisted_66))
              }), 128))
            ], 40, _hoisted_64))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}